import { Component, OnInit } from '@angular/core';
import { PackModel } from '../../models/pack.model';
import { PackService } from '../../services/pack.service';
import { ArticleModel } from '../../models/article.model';
import { Estate } from '../../utils/enum.util';

@Component({
  selector: 'my-pack',
  template: require('./pack.component.html'),
  styles: [require('./pack.component.scss')]
})
export class PackComponent implements OnInit {

  packSelected: PackModel = null;
  packDeleted: PackModel = null;
  listModal: any = {
    'delete' : false
  };

  constructor(public packService: PackService) {
    // Do stuff
  }

  ngOnInit() {
    this.packService.loadAll(false);
  }

  changePack(pack: PackModel){
    this.packService.loadAll(false);
    this.packSelected = pack.clone();
    this.packSelected.validate();
    this.packSelected.validateArticles();
  }

  newPack(){
    this.packSelected = new PackModel(this.packService);
    this.packSelected.state = Estate.Error;
    this.packSelected.articles[0] = new ArticleModel(this.packSelected);
  }

  openDelete(index){
    this.packDeleted = this.packService.packList[index];
    this.listModal.delete = true;
  }

  delete(){
    this.packDeleted.delete();
    this.packSelected = null;
  }

  addArticle(){
    this.packSelected.addArticle();
    //met le focus sur l'input about nouvellement insérer
    try {
      setTimeout(()=> {
        let elements = document.getElementById('articles').getElementsByClassName('article-about');
        elements.item(elements.length - 1).getElementsByTagName('input').item(0).focus();
      }, 100);
    } catch (err){

    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/pages/pack/pack.component.ts